import { render, staticRenderFns } from "./GTextarea.vue?vue&type=template&id=32b991e1&"
import script from "./GTextarea.vue?vue&type=script&lang=js&"
export * from "./GTextarea.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports